module.exports = __webpack_public_path__ + "img/search-icon-with-theme.006a7b8d.svg";